import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBecHV9b6UHAv8jBl7ccZsWBwsb4CJirNo',
  authDomain: 'genomatch-34181.firebaseapp.com',
  projectId: 'genomatch-34181',
  storageBucket: 'genomatch-34181.firebasestorage.app',
  messagingSenderId: '931175472501',
  appId: '1:931175472501:web:06c1a113efe77e5e3fc73c',
};

const app = initializeApp(firebaseConfig);

export { app };
